const ReactRedux = require('react-redux');
const ReactDOM = require('react-dom');

window.ReactDOM = ReactDOM;
window.ReactRedux = ReactRedux;

if (process.env.NODE_ENV == 'development') {
    require('./react_dom_dev');
}
